import { useIlamyCalendarContext } from '@ilamy/calendar';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';

import { DimeButton } from '../DimeButton.js';
import { DimeToggleGroup, DimeToggleGroupItem } from '../DimeToggleGroup.js';
import type { SchedulerView } from './scheduler.types.js';

const VIEW_LABELS: Record<SchedulerView, string> = { month: 'Month', week: 'Week', day: 'Day' };

export function SchedulerHeader() {
  const { currentDate, currentRange, view, nextPeriod, prevPeriod, today, setView } =
    useIlamyCalendarContext();

  let title = currentDate.format('MMMM YYYY');
  if (view === 'week') {
    title = `${currentRange.start.format('MMM D')} – ${currentRange.end.format('MMM D, YYYY')}`;
  } else if (view === 'day') {
    title = currentDate.format('dddd, MMMM D, YYYY');
  }

  return (
    <div className="flex flex-wrap items-center gap-2 pb-2">
      <div className="flex items-center gap-1">
        <DimeButton variant="outline" size="icon-sm" aria-label="Previous" onClick={prevPeriod}>
          <ChevronLeftIcon />
        </DimeButton>
        <DimeButton variant="outline" size="icon-sm" aria-label="Next" onClick={nextPeriod}>
          <ChevronRightIcon />
        </DimeButton>
        <DimeButton variant="outline" size="sm" onClick={today}>
          Today
        </DimeButton>
      </div>
      <h2 className="text-lg font-semibold">{title}</h2>
      <DimeToggleGroup
        type="single"
        variant="outline"
        size="sm"
        className="ml-auto"
        value={view}
        onValueChange={(next) => {
          if (next) {
            setView(next);
          }
        }}
      >
        {(Object.keys(VIEW_LABELS) as SchedulerView[]).map((option) => (
          <DimeToggleGroupItem key={option} value={option}>
            {VIEW_LABELS[option]}
          </DimeToggleGroupItem>
        ))}
      </DimeToggleGroup>
    </div>
  );
}
